module.exports = __webpack_public_path__ + "cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/cd.svg
// module id = 481
// module chunks = 0